import { useEffect } from 'react'

import {
  removeConversation,
  setConversation,
} from '@liveHelper/models/persistence/conversation'
import { conversationSelector, useStore } from '@liveHelper/models/store'

import { persistBusinessMembershipId } from '@core/tracking/funnelTracking'

/** Persists conversation when it changes. */
export function usePersistConversation() {
  const conversation = useStore(conversationSelector)

  useEffect(() => {
    if (conversation?.id) {
      setConversation(conversation.id)
      persistBusinessMembershipId(conversation.business_membership_id)
    } else {
      removeConversation()
    }
  }, [conversation?.business_membership_id, conversation?.id])
}
